import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { BannerUnitService } from "../banner-unit.service";
import { UserInfoService } from "abs-ngx-library/src/lib/core";

@Component({
  selector: "banner-unit-carousel-v1",
  templateUrl: "./banner-unit-carousel-v1.component.html"
})
export class BannerUnitCarouselComponent implements OnChanges, AfterViewInit {
  @ViewChild("bannerUnitCarouselRef", {
    read: ElementRef,
    static: false,
  })
  public bannerUnitCarouselRef: ElementRef;
  public bannerUnitCarouselElement: any = null;
  public _window: any = window;

  @Input() carouselSelector: any;

  constructor(
    private renderer: Renderer2,
    private _bannerUnitService: BannerUnitService,
    private _userInfoService: UserInfoService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['carouselSelector'] && changes['carouselSelector'].currentValue){
      if(this._bannerUnitService.getBannerElementsHtmlMap()?.has(this.carouselSelector)) {
        this.bannerUnitCarouselElement = this._bannerUnitService.getBannerElementsHtmlMap().get(this.carouselSelector).cloneNode(true);
      } else {
        this.bannerUnitCarouselElement = document.querySelector(this.carouselSelector);
        if(this.bannerUnitCarouselElement) {
            this._bannerUnitService.getBannerElementsHtmlMap()?.set(this.carouselSelector, this.bannerUnitCarouselElement.cloneNode(true));
        }
      }
      this.placeCarousel();
    }
  }

  ngAfterViewInit(): void {
    this.checkAdBlockerAndInitGAM();
  }

  checkAdBlockerAndInitGAM() {
    const $this = this;
    // check for AdBlocker check done by GPT
    if (window["checkAdBlocker"] == undefined) {
      // wait for adBlockerLoadChecked event
      window.addEventListener("adBlockerLoadChecked", function (eventResponse) {
        $this.placeCarousel();
      });
    } 
  }

  placeCarousel() {
    const self = this;
    setTimeout(() => {
      //check for component, placeholder and adblocker
      if (
        self.bannerUnitCarouselElement &&
        self.bannerUnitCarouselRef &&
        window["googletag"]?._loaded_ != false
      ) {
        //append banner unit as a node to the placeholder
        self.renderer.appendChild(
          self.bannerUnitCarouselRef.nativeElement,
          self.bannerUnitCarouselElement
        );
        const absCarousel = self.bannerUnitCarouselElement.querySelector('abs-carousel-wc');
        const absLazyFunction = absCarousel?.getAttribute("data-lazy-function");
        if(absLazyFunction) {
            window["lazyFunctions"][absLazyFunction](absCarousel)
        }
      }
    }, 0);
  }
}
